export default "__VITE_ASSET__BWz748hr__"